import { buildModalRoute } from '@manager/modules/modals/routable/modal-routable-utils';
import { routeNames } from '@manager/router/route-names';
import type { RouteMetaConfig } from '@manager/types/router';

export const invoicesRoutes: RouteMetaConfig[] = [
  {
    path: '/invoices',
    name: routeNames.invoiceOverview,
    component: () =>
      import('@manager/modules/invoices/views/InvoicesListView.vue'),
    meta: {
      requiresAuth: true,
      permission: 'invoices.view',
      listFilterName: 'invoices',
    },
    children: [
      buildModalRoute(
        {
          path: 'create',
          name: routeNames.invoiceCreate,
          meta: {
            requiresAuth: true,
            permission: 'invoices.create',
          },
          component: () =>
            import('@manager/modules/invoices/views/InvoiceCreateFormView.vue'),
        },
        { fullscreen: true }
      ),
      buildModalRoute(
        {
          path: 'export/bmd',
          name: routeNames.accountingExportBmd,
          meta: {
            requiresAuth: true,
            permission: 'accounting_exports.create',
          },
          component: () =>
            import('@manager/modules/accounting-export/views/AccountingExportBMDView.vue'),
        },
        { fullscreen: false, width: 'unset' }
      ),
      buildModalRoute(
        {
          path: 'export/xero',
          name: routeNames.accountingExportXero,
          meta: {
            requiresAuth: true,
            permission: 'accounting_exports.create',
          },
          component: () =>
            import('@manager/modules/accounting-export/views/AccountingExportXeroView.vue'),
        },
        { fullscreen: false, width: 'unset' }
      ),
      buildModalRoute(
        {
          path: 'export/datev',
          name: routeNames.accountingExportDatevDownload,
          meta: {
            requiresAuth: true,
            permission: 'accounting_exports.create',
          },
          component: () =>
            import('@manager/modules/datev-export/views/DatevExportDownloadView.vue'),
        },
        { fullscreen: false, width: 'unset' }
      ),
      buildModalRoute(
        {
          path: 'export/datev/configure',
          name: routeNames.accountingExportDatevConfigure,
          meta: {
            requiresAuth: true,
            permission: 'accounting_exports.create',
          },
          component: () =>
            import('@manager/modules/datev-export/views/DatevExportConfigureView.vue'),
        },
        { fullscreen: true }
      ),
      buildModalRoute(
        {
          path: 'export/pdf-export',
          name: routeNames.accountingExportPdfExport,
          meta: {
            requiresAuth: true,
            permission: 'invoices.create',
          },
          component: () =>
            import('@manager/modules/accounting-export/views/AccountingExportPdfExportView.vue'),
        },
        { fullscreen: false, width: 'md' }
      ),
      buildModalRoute(
        {
          path: 'export/fec',
          name: routeNames.fecExport,
          meta: {
            requiresAuth: true,
            permission: 'invoices.create',
          },
          component: () =>
            import('@manager/modules/fec-export/views/FECExportView.vue'),
        },
        { fullscreen: false, width: 'unset' }
      ),
      buildModalRoute(
        {
          path: 'export',
          name: routeNames.invoiceExport,
          meta: {
            requiresAuth: true,
            permission: 'invoices.export',
          },
          component: () => import('./views/InvoiceExportView.vue'),
        },
        { fullscreen: false, width: 'unset' }
      ),
      buildModalRoute(
        {
          path: 'export/credit-note',
          name: routeNames.invoiceExportCreditNote,
          meta: {
            requiresAuth: true,
            permission: 'credit_notes.export',
          },
          component: () =>
            import('@manager/modules/invoices/views/InvoiceCreditNoteExportView.vue'),
        },
        { fullscreen: false, width: 'unset' }
      ),
    ],
  },
  {
    path: '/invoices/:id(\\d+)',
    name: routeNames.invoiceDetails,
    component: () =>
      import('@manager/modules/invoices/views/InvoiceDetailView.vue'),
    meta: {
      requiresAuth: true,
      permission: 'invoices.view',
    },
    children: [
      buildModalRoute(
        {
          path: 'issue-credit-note',
          name: routeNames.invoiceIssueCreditNote,
          meta: {
            requiresAuth: true,
            permission: 'credit_notes.create',
          },
          component: () =>
            import('@manager/modules/invoices/views/InvoiceIssueCreditNoteView.vue'),
        },
        { fullscreen: true }
      ),
      buildModalRoute(
        {
          path: 'issue-late-fee',
          name: routeNames.invoiceIssueLateFee,
          meta: {
            requiresAuth: true,
            permission: 'invoices.create',
          },
          component: () =>
            import('@manager/modules/invoices/views/InvoiceIssueLateFeeView.vue'),
        },
        { fullscreen: true }
      ),
    ],
  },
];

export const invoiceRoutesFactory = {
  invoiceList() {
    return {
      name: routeNames.invoiceOverview,
    };
  },
  invoiceDetails(id: number | string) {
    return {
      name: routeNames.invoiceDetails,
      params: {
        id,
      },
    };
  },
  invoiceIssueCreditNote(invoiceId: number) {
    return {
      name: routeNames.invoiceIssueCreditNote,
      params: {
        id: invoiceId,
      },
    };
  },
  invoiceIssueLateFee(invoiceId: number) {
    return {
      name: routeNames.invoiceIssueLateFee,
      params: {
        id: invoiceId,
      },
    };
  },
};
